import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { ListItemBox } from "lib/@components/ListItemBox"
import { Button, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function Skills({ list, skills }) {
    const { currentTitles } = useBoundContext()
    const [open, setOpen] = useBoundValue("skillsOpen", false)
    if (skills.length < 2) {
        currentTitles.skill = list[0].skill
        return (
            <ListItemBox spacing={1}>
                <Typography variant="body2">{list[0].skill}</Typography>
            </ListItemBox>
        )
    }
    currentTitles.skill = ""
    return (
        <Button
            data-cy="skills-section"
            size="small"
            sx={{ mt: -0.5 }}
            onClick={() => setOpen(!open)}
            endIcon={<Iconify icon={open ? "mdi:keyboard-arrow-down" : "mdi:keyboard-arrow-right"} />}
        >
            Skills ({skills.length})
        </Button>
    )
}
